/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Form_LabelInputs */

const en_event_group_metadata_form_label = /** @type {(inputs: Event_Group_Metadata_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata form`)
};

const fr_event_group_metadata_form_label = /** @type {(inputs: Event_Group_Metadata_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire de métadonnées`)
};

const de_event_group_metadata_form_label = /** @type {(inputs: Event_Group_Metadata_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatenformular`)
};

const it_event_group_metadata_form_label = /** @type {(inputs: Event_Group_Metadata_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo metadati`)
};

const ru_event_group_metadata_form_label = /** @type {(inputs: Event_Group_Metadata_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма метаданных`)
};

const es_event_group_metadata_form_label = /** @type {(inputs: Event_Group_Metadata_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de metadatos`)
};

const zh_cn2_event_group_metadata_form_label = /** @type {(inputs: Event_Group_Metadata_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据表单`)
};

const ja_event_group_metadata_form_label = /** @type {(inputs: Event_Group_Metadata_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータフォーム`)
};

const hi_event_group_metadata_form_label = /** @type {(inputs: Event_Group_Metadata_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा फ़ॉर्म`)
};

const pt_pt2_event_group_metadata_form_label = /** @type {(inputs: Event_Group_Metadata_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário de metadados`)
};

/**
* | output |
* | --- |
* | "Metadata form" |
*
* @param {Event_Group_Metadata_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_form_label = /** @type {((inputs?: Event_Group_Metadata_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_form_label(inputs)
	if (locale === "de") return de_event_group_metadata_form_label(inputs)
	if (locale === "it") return it_event_group_metadata_form_label(inputs)
	if (locale === "ru") return ru_event_group_metadata_form_label(inputs)
	if (locale === "es") return es_event_group_metadata_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_form_label(inputs)
	if (locale === "ja") return ja_event_group_metadata_form_label(inputs)
	if (locale === "hi") return hi_event_group_metadata_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_form_label(inputs)
	return en_event_group_metadata_form_label(inputs)
});